import { useCallback, forwardRef } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { TextField } from "../../atoms";

function isNumeric(num) {
  return num !== undefined && !isNaN(num);
}

export const NumberField = forwardRef(function NumberField(
  { min = 0, max, unit, step = 1, value = min || 0, onChange, ...rest },
  ref
) {
  const onClickUp = useCallback(
    () => {
      if (isNumeric(min) && value < min) {
        onChange(min);
      } else if (isNumeric(max) && value < max) {
        onChange(value + step);
      }
    },
    [value, max, min, onChange, step]
  );
  const onClickDown = useCallback(
    () => {
      if (isNumeric(max) && value > max) {
        onChange(max);
      } else if (isNumeric(min) && value > min) {
        onChange(value - step);
      }
    },
    [value, min, max, onChange, step]
  );

  return (
    <div className="custom-number-field">
      <TextField
        {...rest}
        reference={ref}
        type="string"
        className={rest.className || "productField2small"}
        value={value}
        onChange={(e) => {
          const numValue = Number(e.target.value);
          if (numValue === 0 || numValue) {
            onChange(Number(e.target.value));
          }
        }}
      />
      {unit && (
        <TextField
          name={rest.name}
          className={rest.unitClassName || `productField3small`}
          disabled={true}
          value={unit}
          type="text"
        />
      )}
      <div className="arrows-group">
        <button type="button" onClick={onClickUp}>
          <IoIosArrowUp />
        </button>
        <button type="button" onClick={onClickDown}>
          <IoIosArrowDown />
        </button>
      </div>
    </div>
  );
});
